import {useMemo} from 'react'
import {useGetCurrentUserQuery} from 'store/Store'
import {SIDE_MENU_WIDTH, DRAWER_WIDTH_CLOSED} from 'appearance/styles'
import useResponsive from 'logic/useResponsive'

const usePage = ({open}) => {
    const {mediumScreen} = useResponsive()
    const {data: user} = useGetCurrentUserQuery()

    const {account} = user || {}

    const marginContentPage = useMemo(() => {
        if (mediumScreen) {
            return 0
        } else if (open) {
            return SIDE_MENU_WIDTH
        }
        return DRAWER_WIDTH_CLOSED
    }, [mediumScreen, open])

    return {
        user,
        account,
        marginContentPage,
    }
}

export default usePage
